export default {
  toasts: {
    load_error: 'Failed to load the fee rates',
    failed_to_save_changes: 'Failed to save changes',
    changes_got_saved: 'Changes saved',
  },
  buttons: {
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
  },
  rates: {
    title: 'Processing margin',
    description:
      'Percentage in %, plus an optional fixed and minimum amount per charge. “Any payment method” applies when no method-specific rate exists.',
  },
};
